import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { SortDirection } from './enums/SortDirection.enum'
import { Icon } from '@iconify/vue2'
import { TableColumn } from './dtos/TableColumn.dto'


export default /*#__PURE__*/_defineComponent({
  __name: 'TableHeaderCell',
  props: {
    tableHeader: null
  },
  emits: ["directionChange"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'directionChange', value?: SortDirection): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	tableHeader: TableColumn
};





function handleSort() {
	emit('directionChange', findNextSortDirection())
}

function findNextSortDirection(): SortDirection | undefined {
	switch (props.tableHeader.sortActive) {
		case SortDirection.DESC:
			return undefined
		case SortDirection.ASC:
			return SortDirection.DESC
		default:
			return SortDirection.ASC
	}
}

const sortDirectionIcon = computed(() => {
	switch (props.tableHeader.sortActive) {
		case SortDirection.DESC:
			return 'fa7-solid:sort-amount-desc'
		case SortDirection.ASC:
		default:
			return 'fa7-solid:sort-amount-asc'
	}
})

return { __sfc: true,props, emit, handleSort, findNextSortDirection, sortDirectionIcon, Icon }
}

})